<template>
  <div class="col-12">
    <b-tabs
      card
      fill
      v-model="tabIndex"
      style="border: 1px solid #b2b6b9; border-radius: 6px"
    >
      <b-tab title="Contrato" :active="tabIndex === 0">
        <div class="row">
          <div
            class="form-group col-lg-6"
            :class="{ 'has-error': errors.has('name') }"
          >
            <label for="name">{{ $t("name") }}</label>
            <input
              type="text"
              id="name"
              name="name"
              class="form-control"
              :placeholder="$t('type_name')"
              v-model="contract.codigo_externo_contrato"
              :hasErrors="errors.has('name')"
              v-validate="'required'"
            />

            <small v-show="errors.has('name')" class="form-text text-muted">
              {{ errors.first("name") }}
            </small>
          </div>

          <div class="form-group col-lg-6">
            <label for="social_reason">{{ $t("social_reason") }}</label>
            <input
              type="text"
              id="social_reason"
              name="social_reason"
              class="form-control"
              :placeholder="$t('type_social_reason')"
              v-model="contract.rz_social_contrato"
            />
          </div>

          <div class="form-group col-lg-6">
            <label for="client">{{ $t("client") }}</label>
            <Combobox
              class="bg-white"
              name="client"
              :placeholder="$t('select_a_item')"
              :hasErrors="errors.has('client')"
              :options="clients"
              :initial-value="contract.id_cliente"
              label="nome_cliente"
              v-model="contract.id_cliente"
              :reduce="(client) => client.id"
              v-validate="'required'"
            />

            <small v-show="errors.has('client')" class="form-text text-muted">
              {{ errors.first("client") }}
            </small>
          </div>

          <div class="form-group col-lg-6">
            <label for="services">{{ $t("services") }}</label>
            <Combobox
              class="bg-white"
              name="services"
              :placeholder="$t('select_a_item')"
              :hasErrors="errors.has('services')"
              :options="financialServices"
              :initial-value="contract.id_servico"
              label="nome_servico"
              v-model="contract.id_servico"
              :reduce="(service) => service.id"
              v-validate="'required'"
            />

            <small v-show="errors.has('services')" class="form-text text-muted">
              {{ errors.first("services") }}
            </small>
          </div>

          <div class="form-group col-lg-6">
            <label for="frequency">{{ $t("frequency") }}</label>
            <Combobox
              class="bg-white"
              name="frequency"
              :placeholder="$t('select_a_item')"
              :options="frequencies"
              :initial-value="contract.id_frequencia"
              label="nome_frequencia"
              v-model="contract.id_frequencia"
              :reduce="(service) => service.id"
            />
          </div>

          <div class="form-group col-lg-6">
            <label for="cpf_cnpj">{{ $t("cpf_cnpj") }}</label>
            <input
              type="text"
              id="cpf_cnpj"
              name="cpf_cnpj"
              class="form-control"
              :placeholder="$t('type_cpf_cnpj')"
              v-model="contract.cpf_cnpj_contrato"
            />
          </div>
        </div>
      </b-tab>

      <b-tab title="Consultor" :active="tabIndex === 1">
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="consultant">{{ $t("consultant") }}</label>
            <Combobox
              class="bg-white"
              name="consultant"
              :placeholder="$t('select_a_item')"
              :options="consultants"
              :initial-value="contract.id_consultor"
              label="nome"
              v-model="contract.id_consultor"
              :reduce="(consultant) => consultant.id"
            />
          </div>

          <div class="form-group col-lg-3">
            <label for="monthly_comission"
              >{{ $t("monthly_comission") }} (%)</label
            >
            <CurrencyInputComponent
              id="monthly_comission"
              name="monthly_comission"
              :placeholder="$t('ph_monthly_comission')"
              v-model="contract.comissao_mensalidade"
              :currency="null"
              :precision="2"
            />
          </div>

          <div class="form-group col-lg-3">
            <label for="installation_comission"
              >{{ $t("installation_comission") }} (%)</label
            >
            <CurrencyInputComponent
              id="installation_comission"
              name="installation_comission"
              :placeholder="$t('ph_installation_comission')"
              v-model="contract.comissao_instalacao"
              :currency="null"
              :precision="2"
            />
          </div>

          <div class="switch col-lg-2 mb-3">
            <label for="from_base">{{ $t("from_base") }}</label>
            <div class="onoffswitch2">
              <input
                type="checkbox"
                class="onoffswitch2-checkbox"
                id="from_base"
                v-model="contract.da_base"
              />
              <label class="onoffswitch2-label" for="from_base">
                <span class="onoffswitch2-inner"></span>
                <span class="onoffswitch2-switch"></span>
              </label>
            </div>
          </div>
        </div>
      </b-tab>

      <b-tab title="Endereço" :active="tabIndex === 2">
        <div class="row">
          <div class="form-group col-lg-6">
            <label for="address">{{ $t("address") }}</label>
            <input
              type="text"
              id="address"
              name="address"
              class="form-control"
              :placeholder="$t('ph_address')"
              v-model="contract.endereco_contrato"
            />
          </div>

          <div class="form-group col-lg-2">
            <label for="number">{{ $t("number") }}</label>
            <input
              type="text"
              id="number"
              name="number"
              class="form-control"
              :placeholder="$t('ph_number')"
              v-model="contract.num_endereco"
            />
          </div>

          <div class="form-group col-lg-2">
            <label for="uf">{{ $t("uf") }}</label>
            <Combobox
              class="bg-white"
              name="uf"
              :placeholder="$t('select_a_item')"
              :options="ufs"
              :initial-value="contract.uf_contrato"
              v-model="contract.uf_contrato"
            />
          </div>

          <div class="form-group col-lg-2">
            <label for="cep">{{ $t("cep") }}</label>
            <input
              type="text"
              id="cep"
              name="cep"
              class="form-control"
              :placeholder="$t('type_cep')"
              v-model="contract.cep_contrato"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="city">{{ $t("city") }}</label>
            <Combobox
              :disabled="!cities.length"
              class="bg-white"
              name="city"
              :placeholder="$t('select_a_item')"
              :options="cities"
              :initial-value="contract.cidade_contrato"
              label="nome"
              v-model="contract.cidade_contrato"
              :reduce="(city) => city.nome"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="cod_mun_contrato">{{ $t("ibge_city_code") }}</label>
            <input
              disabled
              type="text"
              id="cod_mun_contrato"
              name="cod_mun_contrato"
              class="form-control"
              v-model="contract.cod_mun_contrato"
              :placeholder="$t('ph_ibge_city_code')"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="neighborhood">{{ $t("neighborhood") }}</label>
            <input
              type="text"
              id="neighborhood"
              name="neighborhood"
              class="form-control"
              :placeholder="$t('type_neighborhood')"
              v-model="contract.bairro_contrato"
            />
          </div>
        </div>
      </b-tab>

      <b-tab title="Flags" :active="tabIndex === 3">
        <div class="row justify-content-between px-3">
          <SwitchComponent
            v-for="item in switches"
            :key="item.id"
            v-model="contract[item.field]"
            :label="item.label"
            :id="item.id"
          />
        </div>
      </b-tab>

      <b-tab title="Valores" :active="tabIndex === 4">
        <div class="row">
          <div
            class="form-group col-lg-3"
            v-for="value in values"
            :key="value.id"
          >
            <label :for="value.id">{{ $t(value.id) }}</label>

            <CurrencyInputComponent
              :value="value.get()"
              @input="value.set && value.set($event)"
              :disabled="value.disabled"
              :readonly="value.readonly"
            />
          </div>
        </div>
      </b-tab>

      <b-tab title="Configuração" :active="tabIndex === 5">
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="start">{{ $t("home") }}</label>
            <input
              type="date"
              id="start"
              name="start"
              class="form-control"
              :placeholder="$t('start')"
              v-model="contract.data_inicio"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="term">{{ $t("term") }} (em meses)</label>
            <input
              type="number"
              id="term"
              name="term"
              class="form-control"
              :placeholder="$t('ph_term')"
              v-model="contract.prazo"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="reading_day">{{ $t("reading_day") }}</label>
            <input
              type="number"
              id="reading_day"
              name="reading_day"
              class="form-control"
              :placeholder="$t('ph_reading_day')"
              v-model="contract.dia_leitura"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="due_day">{{ $t("due_day") }}</label>
            <input
              type="number"
              id="due_day"
              name="due_day"
              class="form-control"
              :placeholder="$t('ph_due_day')"
              v-model="contract.dia_vencimento"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="days_to_block">{{ $t("days_to_block") }}</label>
            <input
              type="number"
              id="days_to_block"
              name="days_to_block"
              class="form-control"
              :placeholder="$t('ph_days_to_block')"
              v-model="contract.dias_bloqueio"
            />
          </div>

          <div class="form-group col-lg-4">
            <label for="due_days_installation">{{
              $t("due_days_installation")
            }}</label>
            <input
              type="number"
              id="due_days_installation"
              name="due_days_installation"
              class="form-control"
              :placeholder="$t('ph_due_days_installation')"
              v-model="contract.dia_vencimento_alterado"
            />
          </div>
        </div>
      </b-tab>

      <b-tab title="Contatos" :active="tabIndex === 6">
        <div class="row">
          <div class="form-group col-lg-3">
            <label for="contact_name">{{ $t("name") }}</label>
            <input
              type="text"
              id="contact_name"
              name="contact_name"
              class="form-control"
              :placeholder="$t('type_name')"
              v-model="contact.nome_cliente_contato"
            />
          </div>

          <div class="form-group col-lg-3">
            <label for="contact_email">{{ $t("email") }}</label>
            <input
              type="text"
              id="contact_email"
              name="contact_email"
              class="form-control"
              :placeholder="$t('type_email')"
              v-model="contact.email_cliente_contato"
            />
          </div>

          <div class="form-group col-lg-2">
            <label for="cargo">{{ $t("cargo") }}</label>
            <input
              type="text"
              id="cargo"
              name="cargo"
              class="form-control"
              :placeholder="$t('ph_cargo')"
              v-model="contact.cargo_cliente_contato"
            />
          </div>

          <div class="form-group col-lg-2">
            <label for="phone1">{{ $t("phone") }} 1</label>
            <the-mask
              type="text"
              id="phone1"
              name="phone1"
              class="form-control"
              :placeholder="$t('type_phone') + ' ' + 1"
              v-model="contact.celular_cliente_contato"
              v-validate="'min:10|max:15'"
              :mask="['(##) ####-####', '(##) #####-####']"
              masked
            />
          </div>

          <div class="form-group col-lg-2">
            <label for="phone2">{{ $t("phone") }} 2</label>
            <the-mask
              type="text"
              id="phone2"
              name="phone2"
              class="form-control"
              :placeholder="$t('type_phone') + ' ' + 2"
              v-model="contact.telefone_cliente_contato"
              v-validate="'min:10|max:15'"
              :mask="['(##) ####-####', '(##) #####-####']"
              masked
            />
          </div>
        </div>

        <div class="row justify-content-between px-3">
          <SwitchComponent
            v-for="item in switchesContact"
            :key="item.id"
            v-model="contact[item.field]"
            :label="item.label"
            :id="item.id"
          />
        </div>

        <div class="row justify-content-end px-3 my-3">
          <button
            v-if="isEditContact"
            type="button"
            class="btn btn-secondary btn-sm m-b ml-3"
            @click="cancelEdit"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="btn btn-primary btn-sm m-b ml-3"
            style="color: black"
            @click="isEditContact ? editContact() : addContact()"
            :disabled="!canAddContact"
          >
            {{ isEditContact ? "Editar" : "Adicionar" }} contato
          </button>
        </div>

        <hr />

        <div class="row">
          <div class="mx-auto col-sm-8 col-lg-12 pb-3" style="overflow-x: auto">
            <table class="table bg-white">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Cargo</th>
                  <th>Telefone(s)</th>
                  <th>Resumo Diário</th>
                  <th>Email-Testar</th>
                  <th>Sem Movimentação</th>
                  <th>Inconsistência</th>
                  <th>Recebe Boleto</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(contact, index) in contract.contacts" :key="index">
                  <td>{{ contact.nome_cliente_contato }}</td>
                  <td>{{ contact.email_cliente_contato }}</td>
                  <td>{{ contact.cargo_cliente_contato }}</td>
                  <td>
                    {{ mountPhone(contact) }}
                  </td>
                  <td>
                    {{ contact.resumo_diario_cliente_contato ? "SIM" : "NÃO" }}
                  </td>
                  <td>
                    {{ contact.email_servico_cliente_contato ? "SIM" : "NÃO" }}
                  </td>
                  <td>
                    {{
                      contact.sem_movimentacao_cliente_contato ? "SIM" : "NÃO"
                    }}
                  </td>
                  <td>
                    {{ contact.inconsistencia_cliente_contato ? "SIM" : "NÃO" }}
                  </td>
                  <td>{{ contact.boleto_cliente_contato ? "SIM" : "NÃO" }}</td>
                  <td style="width: 80px">
                    <button
                      title="Editar contato"
                      type="button"
                      class="btn btn-sm"
                      @click="() => toEditContact(index, contact)"
                    >
                      <i class="fas fa-edit" style="color: #ffc107" />
                    </button>

                    <button
                      :disabled="isEditContact"
                      title="Remover contato"
                      type="button"
                      class="btn btn-sm"
                      @click="() => removeContact(index)"
                    >
                      <i class="fas fa-trash" style="color: red" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <div class="form-group row mt-4">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="save" :loading="isLoading">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton.vue";
import Combobox from "@/components/shared/ComboBox";
import uf from "@/config/uf.js";
import SwitchComponent from "@/components/shared/SwitchComponent.vue";
import FormSection from "@/components/shared/FormSection.vue";
import CurrencyInputComponent from "@/components/shared/CurrencyInputComponent.vue";

const DEFAULT_CONTACT = {
  nome_cliente_contato: "",
  email_cliente_contato: "",
  cargo_cliente_contato: "",
  celular_cliente_contato: "",
  telefone_cliente_contato: "",
  resumo_diario_cliente_contato: true,
  email_servico_cliente_contato: true,
  sem_movimentacao_cliente_contato: true,
  inconsistencia_cliente_contato: true,
  boleto_cliente_contato: true,
};

export default {
  name: "FinancialContractForm",
  components: {
    LoaderButton,
    Combobox,
    SwitchComponent,
    FormSection,
    CurrencyInputComponent,
  },

  data() {
    return {
      ufs: uf,
      switches: [
        {
          id: "dividir_boleto",
          label: "Dividir boleto",
          field: "dividir_boleto",
        },
        {
          id: "instalacao_junto_mensalidade",
          label: "Instalação Junto da Mensalidade",
          field: "instalacao_junto_mensalidade",
        },
        {
          id: "emitir_nfse",
          label: "Emitir Nota Fiscal",
          field: "emitir_nfse",
        },
        {
          id: "retem_iss",
          label: "Retém ISS",
          field: "retem_iss",
        },
        {
          id: "tributado_fora_municipio",
          label: "Tributado fora do município",
          field: "tributado_fora_municipio",
        },
        {
          id: "suspender_cobranca",
          label: "Suspender cobrança",
          field: "suspender_cobranca",
        },
      ],
      switchesContact: [
        {
          id: "resumo_diario_cliente_contato",
          label: "Resumo Diário",
          field: "resumo_diario_cliente_contato",
        },
        {
          id: "email_servico_cliente_contato",
          label: "Email - Testar",
          field: "email_servico_cliente_contato",
        },
        {
          id: "sem_movimentacao_cliente_contato",
          label: "Sem Movimentação",
          field: "sem_movimentacao_cliente_contato",
        },
        {
          id: "inconsistencia_cliente_contato",
          label: "Inconsistência",
          field: "inconsistencia_cliente_contato",
        },
        {
          id: "boleto_cliente_contato",
          label: "Recebe Boleto",
          field: "boleto_cliente_contato",
        },
      ],
      values: [
        {
          id: "locationValue",
          get: () => this.contract.valor_locacao,
          set: (value) => (this.contract.valor_locacao = value),
        },
        {
          id: "softwareValue",
          get: () => this.contract.valor_software,
          set: (value) => (this.contract.valor_software = value),
        },
        {
          id: "telephonyValue",
          get: () => this.contract.valor_telefonia,
          set: (value) => (this.contract.valor_telefonia = value),
        },
        {
          id: "monthly_value",
          get: () => this.monthlyValue,
          disabled: true,
          readonly: true,
        },
        {
          id: "withdrawal_fee",
          get: () => this.contract.valor_retirada,
          set: (value) => (this.contract.valor_retirada = value),
        },
        {
          id: "installation_fee",
          get: () => this.contract.valor_troca || 0,
          set: (value) => (this.contract.valor_troca = value),
        },
        {
          id: "roteirization_value",
          get: () => this.contract.valor_roteirizacao,
          set: (value) => (this.contract.valor_roteirizacao = value),
        },
      ],
      contact: { ...DEFAULT_CONTACT },
      booleanOptions: [
        { label: "SIM", value: true },
        { label: "NÃO", value: false },
      ],
      tabIndex: 0,
    };
  },

  props: {
    contract: {
      type: Object,
      default: () => ({
        id: undefined,
        codigo_externo_contrato: "",
        id_cliente: null,
        id_servico: null,
        id_frequencia: null,
        rz_social_contrato: "",
        cpf_cnpj_contrato: "",
        id_consultor: null,
        da_base: false,
        comissao_mensalidade: 0,
        comissao_instalacao: 0,
        endereco_contrato: "",
        cod_mun_contrato: "",
        num_endereco: "",
        uf_contrato: "",
        cidade_contrato: "",
        bairro_contrato: "",
        cep_contrato: "",
        dividir_boleto: false,
        instalacao_junto_mensalidade: false,
        emitir_nfse: false,
        retem_iss: false,
        tributado_fora_municipio: false,
        suspender_cobranca: false,
        valor_locacao: 0,
        valor_software: 0,
        valor_telefonia: 0,
        valor_retirada: 0,
        valor_roteirizacao: 0,
        valor_troca: 0,
        data_inicio: "",
        prazo: 0,
        dia_leitura: 0,
        dia_vencimento: 0,
        dias_bloqueio: 0,
        dia_vencimento_alterado: 0,
        contacts: [],
      }),
    },
  },

  watch: {
    "contract.uf_contrato": function (value) {
      if (!value) {
        this.contract.cidade_contrato = "";
        this.contract.cod_mun_contrato = "";
        this.$store.commit("ibge/cleanState");

        return;
      }

      this.loadIbgeCitiesByUF(value);
    },

    "contract.cidade_contrato": function (value) {
      if (!value) {
        this.contract.cod_mun_contrato = "";

        return;
      }

      const found = this.cities.find((city) => city.nome === value) || {
        codigo_ibge: "",
      };

      this.contract.cod_mun_contrato = found.codigo_ibge || "";
    },
  },

  computed: {
    ...mapState({
      contracts: (state) => state.contracts.all,
      isLoading: (state) => state.financial.isLoading,
      clients: (state) => state.financial.clients,
      consultants: (state) => state.consultant.all,
      financialServices: (state) => state.financialservice.all,
      frequencies: (state) => state.frequency.all,
      cities: (state) => state.ibge.cities,
    }),

    monthlyValue() {
      const locationValue = Number(this.contract.valor_locacao) || 0;
      const softwareValue = Number(this.contract.valor_software) || 0;

      return Number(locationValue + softwareValue);
    },

    canAddContact() {
      const booleans = [
        this.contact.resumo_diario_cliente_contato,
        this.contact.email_servico_cliente_contato,
        this.contact.sem_movimentacao_cliente_contato,
        this.contact.inconsistencia_cliente_contato,
        this.contact.boleto_cliente_contato,
      ];

      const booleansOk = booleans.every((bool) => [true, false].includes(bool));

      return (
        this.contact.nome_cliente_contato &&
        this.contact.email_cliente_contato &&
        this.contact.cargo_cliente_contato &&
        booleansOk
      );
    },

    isEditContact() {
      return this.contact.index !== undefined;
    },
  },

  methods: {
    ...mapActions("contracts", ["create", "edit", "cleanState"]),

    async save(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id, ...rest } = this.contract;

      const result = id
        ? await this.edit({ id, data: rest })
        : await this.create(rest);

      if (result) {
        this.$router.push({ name: "listfinancialcontract" });
      }
    },

    async loadIbgeCitiesByUF(uf) {
      await this.$store.dispatch("ibge/fetchCitiesByUF", uf);
    },

    addContact() {
      this.contract.contacts.push({ ...this.contact });

      this.contact = { ...DEFAULT_CONTACT };
    },

    removeContact(indexToRemove) {
      this.contract.contacts = this.contract.contacts.filter(
        (_, index) => index != indexToRemove
      );
    },

    toEditContact(indexToEdit, contact) {
      this.contact = {
        index: indexToEdit,
        ...contact,
        celular_cliente_contato: String(contact.celular_cliente_contato || "").replace(/\D/g, ""),
        telefone_cliente_contato: String(contact.telefone_cliente_contato || "").replace(/\D/g, ""),
      };
    },

    editContact() {
      const { index, ...rest } = this.contact;

      const newContacts = this.contract.contacts.map((contact, arrayIndex) => {
        if (arrayIndex != index) {
          return contact;
        }

        return rest;
      });

      this.contract.contacts = newContacts;

      this.contact = { ...DEFAULT_CONTACT };
    },

    cancelEdit() {
      this.contact = { ...DEFAULT_CONTACT };
    },

    mountPhone(contact) {
      const phones = [
        contact.celular_cliente_contato,
        contact.telefone_cliente_contato,
      ];

      return phones.filter((phone) => phone).join(" / ");
    },
  },

  async mounted() {
    const { dispatch } = this.$store;

    try {
      const toFetch = [
        "financial/fetchClients",
        "consultant/fetchAll",
        "financialservice/fetchAll",
        "frequency/fetchAll",
      ];

      dispatch("overlay/show", {
        isShow: true,
        message: "Carregando dados ...",
      });

      await Promise.all(toFetch.map((action) => dispatch(action)));
    } catch (error) {
      console.log("[ERROR-TO-FETCH-MOUNTED] => ", error);
    } finally {
      dispatch("overlay/show", false);
    }
  },

  destroyed() {
    this.cleanState();
  },
};
</script>

<style>
.nav-link {
  color: #6b6b6b !important;
}
.nav-link.active {
  color: black !important;
}
</style>
